import { defineComponent as _defineComponent } from 'vue'
import { Heading, BaseText } from '@warrenbrasil/nebraska-web';
import { HeaderSubtitleLoader } from '@/modules/trade/views/TradePositionsView/components/Loaders';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  updatedAt?: string;
  isLoading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomOperationsHeader',
  props: {
    updatedAt: { default: undefined },
    isLoading: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true,Heading, BaseText, HeaderSubtitleLoader, NebraskaColors }
}

})